import axios from "axios";

export const apiUrlServidores = `${process.env.TRANSPARENCY_API_URL}/servidores`;

const axiosClient = axios.create({
  baseURL: `${apiUrlServidores}`,
  timeout: 0,
  headers: {},
});

export async function getServidoresDetalhamento(
  exercicio: string,
  id: string
): Promise<any> {
  try {
    const { data } = await axiosClient.get(
      `/${exercicio}/${id}/detalhamento/`,
      {
        headers: {
          "Accept-Encoding": "gzip, deflate, br",
          Accept: "application/json, text/plain, */*",
        },
      }
    );
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getServidoresListagem(
  exercicio: string,
  referencia: string
): Promise<any> {
  try {
    const { data } = await axiosClient.get(`/${exercicio}/${referencia}/`, {
      headers: {
        "Accept-Encoding": "gzip, deflate, br",
        Accept: "application/json, text/plain, */*",
      },
    });
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getServidoresDownload(
  exercicio: string,
  referencia: string
): Promise<any> {
  try {
    const response = await axiosClient.get(
      `/${exercicio}/${referencia}/download/`,
      {
        responseType: "blob",
        headers: {
          "Accept-Encoding": "gzip, deflate, br",
        },
      }
    );
    return Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getServidoresExercicios(): Promise<any> {
  try {
    const { data } = await axiosClient.get(`/exercicios/`, {
      headers: {
        "Accept-Encoding": "gzip, deflate, br",
        Accept: "application/json, text/plain, */*",
      },
    });
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getServidoresOrgaos(
  exercicio: string,
  referencia_ate: string,
  referencia_de: string
): Promise<any> {
  try {
    const { data } = await axiosClient.get(`/orgaos/`, {
      headers: {
        "Accept-Encoding": "gzip, deflate, br",
        Accept: "application/json, text/plain, */*",
      },
    });
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getServidoresReferencias(
  exercicio: string
): Promise<any> {
  try {
    const { data } = await axiosClient.get(`/referencias/${exercicio}/`, {
      headers: {
        "Accept-Encoding": "gzip, deflate, br",
        Accept: "application/json, text/plain, */*",
      },
    });
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getServidoresLastUpdate(): Promise<any> {
  try {
    const { data } = await axiosClient.get(`/updated_at/`, {
      headers: {
        "Accept-Encoding": "gzip, deflate, br",
        Accept: "application/json, text/plain, */*",
      },
    });
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}
